
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8hgjP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9916e5e90b290a19$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $Uvuzz = parcelRequire("Uvuzz");

class $9916e5e90b290a19$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.displayName = 'MediaPickerAnalyticsErrorBoundary';
    }
    render() {
        const { data: data = {}, children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Uvuzz.default), {
            channel: (0, $4fb7dcf3ec2949f7$export$ec1779cb96554e1),
            data: data,
            children: children
        });
    }
}

});
const $4fb7dcf3ec2949f7$export$ec1779cb96554e1 = 'media';



//# sourceMappingURL=@atlaskit-internal_media-picker-error-boundary.3eeff9c7.js.map
